export type LensCatalogItem = {
    catalog_id: number;
    attribute_id: number;
    attribute_key: string;
    display_name: string;
    attribute_nature: string;
    dimension: string | null;
    ui_role: string;
    is_selected: boolean;
    is_display_enabled?: boolean | null;
    is_disabled: boolean;
    disabled_reason: string | null;
};

export type LensCatalogGroup = {
    group_key: string;
    group_name: string;
    items: LensCatalogItem[];
};

export type LensCatalogSection = {
    section_key: string;
    section_name: string;
    groups: LensCatalogGroup[];
};

export type LensCatalogData = {
    sections: LensCatalogSection[];
};

export type LensCatalogFetchResult = {
    lensId: number | null;
    catalog: LensCatalogData;
    raw: unknown;
};

/** Section keys returned by GET /ppa/lens-config */
export const LENS_CATALOG_SECTION_KEYS = {
    SYSTEM_COLUMNS: 'system_columns',
    DIMENSIONS: 'dimensions',
    KPIS: 'kpis',
} as const;
